import { render } from "./Default3Page.vue?vue&type=template&id=1f086a20"
import script from "./Default3Page.vue?vue&type=script&lang=js"
export * from "./Default3Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__